module.exports = new __parcel__URL__("5.6b69b1fd.svg").toString();